import React, { useEffect, useState, useCallback, useRef } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleUp, faAngleDown} from "@fortawesome/free-solid-svg-icons";
import {useSelector} from "react-redux";
import axios from 'util/axios';
import UserList from "./UserList";

const RevData = ({ data,replySave,cmptTypeUpdate,revInputs,revUserList,revExternalSave }) => {
    const [comnShowing, setComnShowing] = useState(false);
    const replyTextRef = useRef(null);
    const toggleComnShwoing = () => {
        setComnShowing(prev => !prev);
    }
    const [inputActive, setInputActive] = useState(false);
    const userSelector = useSelector((store) => store.user);
    const externalAuth = userSelector.userAuth.filter((f) => f.code === "20")
    const [userState, setUserState] = useState(false);
    const [userList, setUserList] = useState(
        {label : "", value : ""}
    );

    const [replyInputs, setReplyInputs] = useState({
        sheetCode:data.sheetCode
        ,revision:data.revision
        ,uniqueCode: data.uniqueCode
        ,celNm:data.celNm
        ,revNo:data.revNo
        ,revContent:""
        ,userId:userSelector.userId
        ,externalViewYn:data.externalViewYn
    });
    useEffect(() => {
        setReplyInputs(
            {
                sheetCode:data.sheetCode
                ,revision:data.revision
                ,uniqueCode: data.uniqueCode
                ,celNm:data.celNm
                ,revNo:data.revNo
                ,revContent:""
                ,userId:userSelector.userId
                ,externalViewYn:data.externalViewYn
            }
        )
    }, [data]);



    const activateInput = () => {
        setInputActive(true);
        setComnShowing(true);
    }
    const deActivateInput = () => {
        setInputActive(false)
    }

    const onChangeInputHandler=(e) =>{
        const textData = e.target.innerText;
        let user = revUserList.filter(data => data.label.toLowerCase().indexOf(textData.toLowerCase().substring(textData.lastIndexOf('@')+1,textData.length)) !== -1);
        if(user.length !== 0 && textData !== '' && textData.substring(textData.lastIndexOf('@'),textData.lastIndexOf('@')+1) === '@'){
            setUserState(true);
        }else{
            setUserState(false);
        }
        setUserList(user);

    }
    const onReplySaveHandler=(e) =>{


        const payload = {
            ...replyInputs,
            revContent: replyTextRef.current.innerHTML,
            revLevel: 2
        }

        replySave(payload,setReplyInputs);
    }

    const userClick = (data) =>{

        const revContentHtml = replyTextRef.current.innerHTML;
        const revContentText = replyTextRef.current.innerText;
        const textData = revContentHtml?.substring(revContentHtml.lastIndexOf('@'),-1);

            const payloadHtml  = textData +'<span suppressContentEditableWarning={true} contentEditable="false" data-userid="'+data.value+'" class="bpl-reviewerspan">'+'@'+data.label+'</span>'
        setUserState(false);


        const payload = {
            ...replyInputs,
            revContent: payloadHtml,
            revLevel: 2
        }
        setReplyInputs(payload);
    }

    const revExternal = (e) =>{
        const payload = {
            ...replyInputs,
            externalViewYn: e.target.checked ? "Y" : "N",
            celNm: data.celNm,
            revision: data.revision,
            sheetCode: data.sheetCode,
            revNo: data.revNo,
            uniqueCode: data.uniqueCode,
            groupId:data.groupId
        }
        revExternalSave(payload,setReplyInputs)
    }

    let now = new Date
    let year = now.getFullYear()
    let month = (now.getMonth()+1) > 9 ? (now.getMonth()+1) : '0'+(now.getMonth()+1)
    let date = now.getDate();
    const isCompleted = data.cmptType !== "R";
    return (
        <>
            <div>
                <div style={{color:isCompleted ? "#aaa": "", opacity: isCompleted ? 0.5 : 1}}>
                    <div style={{paddingBottom:10,borderTop:"1px solid #aaa"}} id="show1" >
                        <div style={{display:"flex",paddingTop:12}}>
                            <div style={{flex:"1"}}><label style={{fontWeight:"bold"}}>{data.userNm}</label> <small>{data.createDt}</small> <span onClick={toggleComnShwoing} style={{cursor:"pointer"}}>{comnShowing ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}</span></div>
                            {revInputs.tempYn === 'Y' &&
                            <div style={{paddingRight:"5px",cursor:"pointer"}} onClick={inputActive?deActivateInput : activateInput}>{data.cmptType === "R"? inputActive ?'닫기':'답글':""}</div>
                            }
                            
                            {revInputs.tempYn === 'Y' &&
                            <div style={data.cmptType ==='R' ? {color: "green",cursor:"pointer"} : {color: "red",cursor:"pointer",marginRight: "10px"}} onClick={() => cmptTypeUpdate(data.cmptType,data.revNo,data.groupId)}>{data.cmptType === 'R' ? 'complete': 'cancel'}</div>
                            }
                            { externalAuth?.length === 0 ? (
                                <div className={`radio-group`}>
                                    <input
                                        type="checkbox"
                                        id={`externalCmp`}
                                        onClick={(e)=>revExternal(e)}
                                        checked={data.externalViewYn === "Y"}
                                        onChange={(e) => {}}
                                    />
                                    external
                                </div>
                                ):null
                            }
                        </div>
                        <div style={{marginLeft:20,wordBreak: "break-word"}} dangerouslySetInnerHTML={ {__html: data.content}}></div>

                    </div>
                    <div style={{padding: "0 20px 0 20px"}}>
                    {comnShowing && data.comn.map((comnData, i) =>
                    <div key={`comData-${i}`}>
                        <div >
                            <div style={{paddingBottom:3}}>↳<label style={{fontWeight:"bold"}}>{comnData.userNm}</label> <small>{comnData.createDt}</small></div>
                            <div style={{marginLeft:20,wordBreak: "break-word"}} dangerouslySetInnerHTML={ {__html: comnData.revContent}}></div>
                        </div>
                    </div>
                    )}
                    <div>
                        {inputActive ? (
                                <div>
                                    <div style={{paddingTop:15}}>
                                        <div style={{paddingBottom:3}}>↳<label style={{fontWeight:"bold"}}>{userSelector.userNm}</label> <small>{year+"-"+month+"-"+date}</small></div>
                                        <div style={{display : "flex", gap: 10, paddingLeft: 15,marginBottom: "5px"}}>
                                            <div style={{width:"100%"}}>
                                                <div style={{flex: 1,border:"1.5px #000 solid",borderRadius: "5px"}}
                                                     suppressContentEditableWarning={true}
                                                     contentEditable="true"
                                                     onKeyUp={(e) => onChangeInputHandler(e)}
                                                     dangerouslySetInnerHTML={ {__html: replyInputs.revContent}}
                                                     ref = {replyTextRef}>{/*<input style={{padding:"3px", width: "100%", height: "100%"}} type="text" value={replyInputs.revContent} onChange={onChangeInputHandler}/>*/}</div>
                                                {userState &&
                                                    <div style={{position: "absolute", border: "1px solid #aaa", background: "white",width: "72%"}}>
                                                        <UserList user = {userList} userClick = {userClick} />
                                                    </div>
                                                }
                                            </div>
                                                {inputActive && <button style={{width: 50}} onClick={() =>{
                                                    onReplySaveHandler();
                                                    setComnShowing(true);
                                                    setInputActive(false);
                                                }}>저장</button>}
                                        </div>

                                    </div>
                                </div>
                        ) : null}
                    </div>
                    </div>

                </div>
            </div>

        </>
//
    )

}

export default React.memo(RevData);
